/**
 * @generated SignedSource<<7cebb5b5707e4635ed41f64bf7808629>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentFlaggingsChipFragment$data = {
  readonly flaggings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContentFlaggingListPopoverFragment">;
  readonly " $fragmentType": "ContentFlaggingsChipFragment";
};
export type ContentFlaggingsChipFragment$key = {
  readonly " $data"?: ContentFlaggingsChipFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentFlaggingsChipFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentFlaggingsChipFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentFlaggingNodeConnection",
      "kind": "LinkedField",
      "name": "flaggings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentFlaggingNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentFlagging",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentFlaggingListPopoverFragment"
    }
  ],
  "type": "Content",
  "abstractKey": null
};

(node as any).hash = "c9dca1b9cb8f8f387e135d4accf3270b";

export default node;
